import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import {addEditRolesReady} from '../redux/roles'
import apiService from '../services/apiservices'
import { headerDataUpdate,subHeaderDataUpdate, buildNumberUpdate } from '../../../redux/user'
import * as Constants from '../../../common/constants'
//import  {ValidateEmail ,ValidatePhone,isLatitude,isLongitude} from '../../../common/ValidationFunctions/CommonValidation'

//import * as Helpers from '../../../common/helpers'

import {RolesType} from './DropDowns/index'

class AddEditRoles extends Component {

  constructor() {
    super()
    this.state = {

        bodyHeight: "0px",
        editFlag:false,

        rolesName: "",
        rolesRemarks: "",
        rolesType: "",

        rolesData:[],

        privilegesList:[],
        selectedPrivileges:[],
        deletedPrivileges:[],



        rolesNameErrorText: false,
        rolesNameErrorData: '',

        rolesRemarksErrorText: false,
        rolesRemarksErrorData: '',

        rolesTypeErrorText: false,
        rolesTypeErrorData: '',

        subTitle: Constants.ADD_ROLE

    }

    this.isComponentStillMounted = true

    this.rolesNameComponent = null
    this.rolesNameSection = null


    this.rolesRemarksComponent = null
    this.rolesRemarksSection = null

    this.rolesTypeComponent = null
    this.rolesTypeSection = null


}

componentWillMount() {
    this.isComponentStillMounted = true
    this.props.dispatch(addEditRolesReady(false))

    if (this.props.roles && this.props.roles.rolesSelectedId && this.props.roles.rolesSelectedId !== null) {
        this.props.dispatch(headerDataUpdate(Constants.EDIT_ROLE))
        this.setState({
            subTitle: "Edit Role",
            editFlag:true
        })
    } else {
        this.props.dispatch(headerDataUpdate(Constants.ADD_ROLE))
        this.setState({
            subTitle: "Add Role"
        })
    }
    this.props.dispatch(subHeaderDataUpdate())

    window.addEventListener("resize", this.updateDimensions)
    this.updateDimensions()


    this.getPrivilegesComboList()


    // if (this.props.roles && this.props.roles.rolesSelectedId && this.props.roles.rolesSelectedId !== null) {
    //     this.getRolesById(this.props.roles.rolesSelectedId)
    // }else{

    // this.props.dispatch(addEditRolesReady(true))
    // }
}

componentDidMount() {

        this.rolesNameSection = ReactDOM.findDOMNode(this.refs.rolesNameSection)
        this.rolesRemarksSection = ReactDOM.findDOMNode(this.refs.rolesRemarksSection)
        this.rolesTypeSection = ReactDOM.findDOMNode(this.refs.rolesTypeSection)

}

updateDimensions = () => {
    if (window.innerWidth <= 767) {
        this.setState({
            bodyHeight: (window.innerHeight - 150) + "px",
        })
    } else {
        this.setState({
            bodyHeight: (window.innerHeight - 120) + "px",
        })
    }
}

validateBuildNumber = (data) => {
    if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
        if (this.props.user.build_number === data.app_build_no) {
            //do smthng here
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    } else {
        this.props.dispatch(buildNumberUpdate(data.app_build_no))
        window.location.reload()
    }
}

componentWillUnmount() {
    this.isComponentStillMounted = false
    window.removeEventListener("resize", this.updateDimensions)
}


mandateValidation = (inputName, type) => {
    let inputComponent = inputName + "Component"
    let inputErrorText = inputName + "ErrorText"
    let inputErrorData = inputName + "ErrorData"
    let inputSection = inputName + "Section"
    let errorMsg = Constants.NON_VALID_MSG_INPUT
    if (Constants.FORM_SELECT === type) {
        errorMsg = Constants.NON_VALID_MSG_SELECT
        console.log("input name :::", inputName)
        console.log("input data :::", this.state[inputName])
    }
    if (this.state[inputName] === null || this.state[inputName] === undefined || this.state[inputName] === "") {
        this[inputComponent].focus()
        this.setState({
            [inputErrorText]: true,
            [inputErrorData]: errorMsg
        })
        this[inputSection].className = this[inputSection].className.replace(" has-error", "")
        this[inputSection].className += " has-error"
        return {
            status: false,
            value: ''
        }
    }
    return {
        status: true
    }
}

onSaveClick = () => {

    this.props.dispatch(addEditRolesReady(false))
    let data = {}

    let rolesNameObject = this.mandateValidation("rolesName", Constants.FORM_INPUT)
    if (rolesNameObject.status) {
        data.name = this.rolesNameComponent.value
    } else {

         this.props.dispatch(addEditRolesReady(true))
        return
    }


    let rolesTypeObject = this.mandateValidation("rolesType", Constants.FORM_SELECT)
    if (rolesTypeObject.status) {
        data.type = this.rolesTypeComponent.value
    } else {
         this.props.dispatch(addEditRolesReady(true))
        return
    }


     let rolesRemarksObject = this.mandateValidation("rolesRemarks", Constants.FORM_INPUT)
    if (rolesRemarksObject.status) {
        data.remarks = this.rolesRemarksComponent.value
    } else {
         this.props.dispatch(addEditRolesReady(true))
        return
    }




    data.privileges = this.state.selectedPrivileges

    if(this.state.deletedPrivileges.length>0){
            data.privileges=data.privileges.concat(this.state.deletedPrivileges)
    }


    let apiPayloadData=data;


    if(this.state.editFlag){


        apiService.editRoles(apiPayloadData,this.state.rolesData.id)
            .then(responseData => {
                 
                    if (responseData.status === "SUCCESS") {
                        this.props.dispatch(addEditRolesReady(true))
                        this.props.history.push("/dashboard/roles/list")
                    } else {

                        this.props.dispatch(addEditRolesReady(true))
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.props.dispatch(addEditRolesReady(true))
                console.error("Error data: ", err)
               alert("exception"+ err);
            })


    }else{

    apiService.addRoles(apiPayloadData)
            .then(responseData => {
                 
                    if (responseData.status === "SUCCESS") {
                        this.props.dispatch(addEditRolesReady(true))
                        this.props.history.push("/dashboard/roles/list")
                    } else {

                        this.props.dispatch(addEditRolesReady(true))
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.props.dispatch(addEditRolesReady(true))
                console.error("Error data: ", err)
               alert("exception"+ err);
            })


    }


}

integerValidation = (value) => {
    if (/\D/.test(value)) {
        return true
    } else {
        return false
    }
}

onCancelClick = () => {
    this.props.history.goBack()
}



getPrivilegesComboList = () => {
    apiService.getPrivilegesComboList()
        .then(responseData => {
            if (responseData) {

                if (responseData && responseData.data) {
                    let data = Object.entries(responseData.data);

                    data.sort(function(a, b) { return (a[1] > b[1] ? 1 : (a[1] === b[1] ? 0 : -1)) })

                    this.setState({
                        privilegesList: data
                    })

                    if(!this.state.editFlag){
                        this.renderSelectOption(data)
                        this.props.dispatch(addEditRolesReady(true))
                    }else{

                         if (this.props.roles && this.props.roles.rolesSelectedId && this.props.roles.rolesSelectedId !== null) {
                            this.getRolesById(this.props.roles.rolesSelectedId)                           
                        }
                    }            

                }

            }


        })
        .catch(err => {
            console.error("Error data: ", err)
            this.props.dispatch(addEditRolesReady(true))
        })
}




getRolesById = (id) => {
    apiService.getRolesById(id)
        .then(responseData => {
            if (responseData.status === "SUCCESS") {

                if (responseData && responseData.data) {                   
                    this.setState({
                        rolesData: responseData.data ,
                        rolesName : responseData.data.name,
                        rolesType:responseData.data.type,
                        rolesRemarks : responseData.data.remarks                   
                    })

                    if (this.isComponentStillMounted) {
                        this.rolesNameComponent.value=responseData.data.name
                        this.rolesTypeComponent.value=responseData.data.type
                        this.rolesRemarksComponent.value=responseData.data.remarks
                    }

                    this.filterData(responseData.data)
                    //this.props.dispatch(addEditRolesReady(true))             

                }

            }


        })
        .catch(err => {
            console.error("Error data: ", err)
             this.props.dispatch(addEditRolesReady(true))
        })
}




filterData = (data) => {

    if(data){

            let privData=[]

            let privileges=data.role_privileges;

            for(let i=0;i<privileges.length;i++){
            
                let temp={}

                temp['role_privilege_id']=privileges[i].id;
                temp['privilege_id']=privileges[i].privilege_id;
                temp['privilege_name']=privileges[i].privilege.name;
                temp['scoped']=privileges[i].is_scoped

                 privData.push(temp)
            }

            this.setState({
                selectedPrivileges: privData
            });

            let privilegesList = this.state.privilegesList
            let selectedPrivileges = this.state.selectedPrivileges

            //let index = rolesList.indexOf(selectedValue);

            selectedPrivileges.map(function(item) {
                privilegesList.map(function(item2,index) {
                    if (parseInt(item2[0],10) === item.privilege_id) {
                        if (index > -1) {
                            privilegesList.splice(index, 1); // 2nd parameter means remove one item only
                        }
                    }
                    return true
                });
                return true
            })



            this.setState({
                privilegesList: privilegesList
               }); 


         this.renderSelectOption(privilegesList)
         this.props.dispatch(addEditRolesReady(true))
    }
}



   rolesTypeChange = (data) => {
    this.rolesTypeComponent.value=data.value
        this.setState({
            rolesType :data.value,
            rolesTypeErrorText: false,
            rolesTypeErrorData: ''
        })
        this.rolesTypeSection.className= this.rolesTypeSection.className.replace(" has-error", "")
    }


    renderSelectOption = (data) => {

    let privilegesList = data;
    let temp = '<select id="privilegeId" class="form-control">';
    for (let i = 0; i < privilegesList.length; i++) {
        temp += '<option value="' + privilegesList[i][0] + '">' + privilegesList[i][1] + '</option>';
    }
    temp += '</select>';
    let selectedElement = document.getElementById("selectIdRender");
    selectedElement.innerHTML = "";
    selectedElement.innerHTML = temp;


    //selectIdRender
}
   


addPrivilegeBtn = () => {

    let selectedValueId = document.getElementById("privilegeId").value;
    let selectedValueText = document.getElementById("privilegeId").options[document.getElementById("privilegeId").selectedIndex].text;
    let checkedValue = document.getElementById("checkbox_id").checked;
    let selectedPrivileges = this.state.selectedPrivileges;
    


    let deletedPrivileges = this.state.deletedPrivileges;

    if(this.state.editFlag){
        let index_d;
        let role_privilege_id;
         deletedPrivileges.map(function(item, index) {
            if (item['privilege_id'] === selectedValueId) {
                index_d = index
                role_privilege_id=item['role_privilege_id']
            }
            return true
        })

         selectedPrivileges.push({
            "role_privilege_id":role_privilege_id,
            "privilege_id": selectedValueId,
            "privilege_name": selectedValueText,
            "scoped": checkedValue
        });

        if (index_d > -1) {
            deletedPrivileges.splice(index_d, 1); // 2nd parameter means remove one item only
        }



    }else{

        selectedPrivileges.push({
            "privilege_id": selectedValueId,
            "privilege_name": selectedValueText,
            "scoped": checkedValue
        });
    }
    

    this.setState({
        selectedPrivileges: selectedPrivileges
    });


    let privilegesList = this.state.privilegesList

    //let index = rolesList.indexOf(selectedValue);
    let index_i;
    privilegesList.map(function(item, index) {
        if (parseInt(item[0],10) === parseInt(selectedValueId,10)) {
            index_i = index
        }
        return true
    })

    if (index_i > -1) {
        privilegesList.splice(index_i, 1); // 2nd parameter means remove one item only
    }

    this.setState({
        privilegesList: privilegesList
    });

    this.renderSelectOption(this.state.privilegesList)
}


removePrivilege = (privilege_id) => {

    let selectedPrivileges = this.state.selectedPrivileges;
    let deletedPrivileges = this.state.deletedPrivileges;


    let index_i;
    let privilege_name;

    selectedPrivileges.map(function(item, index) {
        if (item['privilege_id'] === privilege_id) {
            index_i = index
            privilege_name = item['privilege_name']
        }
        return true
    })

    if(this.state.editFlag && selectedPrivileges[index_i]['role_privilege_id']){

        selectedPrivileges[index_i]['is_deleted']=1
        deletedPrivileges.push(selectedPrivileges[index_i])

        this.setState({
            deletedPrivileges: deletedPrivileges
        });
    }

    if (index_i > -1) {        
            selectedPrivileges.splice(index_i, 1);
    }

    this.setState({
        selectedPrivileges: selectedPrivileges
    });

    let privilegesList = this.state.privilegesList

    privilegesList.push([privilege_id, privilege_name]);

    this.setState({
        privilegesList: privilegesList
    });

    this.renderSelectOption(this.state.privilegesList)

}


checkBoxChange = (privilege_id,e) => {

    let selectedPrivileges = this.state.selectedPrivileges;

    selectedPrivileges.map(function(item, index) {
        if (item['privilege_id'] === privilege_id) {
            item.scoped = e.target.checked
        }
        return true
    })

     this.setState({
        selectedPrivileges: selectedPrivileges
    });

}


    render() {
        return (
            <div className="line-item-edit">

                <div className="col-md-12" style={{ "paddingBottom" : "1%"}}>
                    <a href="" 
                        onClick={(e) => {e.preventDefault() 
                                    this.props.history.goBack()}}> 
                            <i class="fa fa-arrow-left" aria-hidden="true"></i> Go Back
                    </a>
                </div>


                <Dialog ref={el => this.dialog = el} />
                <section className="content">
                    <div className="row">
                        <div className="col-md-12 col-sm-12 col-xs-12" style={{ height: this.state.bodyHeight }}>
                            <div className="box box-info" style={{ borderTop: "0px" }}>
                                <div className="box-header with-border">
                                    <h3 className="box-title" style={{ fontWeight: 600 }}>{this.state.subTitle}</h3>
                                </div>
                                <div className="form-horizontal">
                                    <div className="box-body" style={{ marginTop: "20px", marginBottom: "20px" }}>
                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group" ref={el => this.rolesNameSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Role Name *</label>
                                                    <div className="col-sm-9">
                                                        <input className="form-control" placeholder="Enter Role Name" type="text" ref={el => this.rolesNameComponent = el}
                                                            onChange={(e) => {e.preventDefault() 
                                                            this.keyedInputChange("rolesName")}} />
                                                        <span className="help-block"style={{display: this.state.rolesNameErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.rolesNameErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                            <div className="form-group" ref={el => this.rolesTypeSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Role Type *</label>
                                                    <div className="col-sm-9" ref={el => this.rolesTypeComponent = el}>
                                                        
                                                         <RolesType rolesTypeChange={this.rolesTypeChange} selectedValue={this.state.rolesType} />

                                                        <span className="help-block"style={{display: this.state.rolesTypeErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.rolesTypeErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            </div>


                                         <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-6 col-sm-12 col-xs-12">

                                                <div className="form-group">
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Roles Remarks*</label>
                                                    <div className="col-sm-9" ref={el => this.rolesRemarksSection = el}>
                                                         <input className="form-control" placeholder="Enter Remarks" type="text" ref={el => this.rolesRemarksComponent = el}
                                                            onChange={(e) => {e.preventDefault() 
                                                            this.keyedInputChange("rolesRemarks")}} />

                                                            <span className="help-block" style={{ display: this.state.rolesRemarksErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                                                                {this.state.rolesRemarksErrorData}
                                                            </span>
                                                    </div>
                                                </div>

                                            
                                            </div>

                                            </div>   

                                              <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-6 col-sm-12 col-xs-12">

                                                <div className="form-group">
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Select Privileges*</label>
                                                    <div className="col-sm-9" id="selectIdRender">
                                                        <select id="privilegeId" className="form-control">
                                                          
                                                        </select>
                                                    </div>
                                                </div>

                                            
                                            </div>

                                             <div className="col-md-6 col-sm-12 col-xs-12">

                                             <div className="col-md-2">
                                                <div className="form-group">
                                                    <input className="checkbox" type="checkbox" name="checkbox" id="checkbox_id" value="value" style={{"float": "left"}}/>
                                                    <label for="checkbox_id" style={{"float": "left","margin": "4px 6px"}}>Scoped</label>

                                                    </div>
                                                </div>


                                             <div className="col-md-6">
                                                <div className="add-btn-box">
                                                     <button
                                                        className="btn btn-info"
                                                        onClick={(e) => {
                                                            e.preventDefault()
                                                            this.addPrivilegeBtn()
                                                        }}>
                                                        Add
                                                    </button>
                                                </div>
                                                </div>

                                                </div>

                                                </div>                                    
                                        

                                            
                                                </div>
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                            </div>
                                        </div>



                                          {(() => {

                                       if(this.state.selectedPrivileges.length>0){
                                                                        return (
                                        <div className="col-md-12">
                                        <div className="col-md-6">
                                         <div className="form-horizontal">
                                    <div className="box-body" style={{ marginTop: "20px", marginBottom: "20px" }}>
                                    <h4>Selected Privileges</h4>


                                        <table className="table table-bordered" style={{textAlign:"left"}}>
                                    
                                                        <thead>
                                                            <tr><th>Privileges Name</th><th>Scoped</th><th>Delete</th></tr>
                                                        </thead>
                                                        <tbody>
                                                         {this.state.selectedPrivileges.map((item, index) => (

                                                        <tr><td>{this.state.selectedPrivileges[index].privilege_name}</td>
                                                        <td><input className="checkbox" type="checkbox" name="checkbox" value="value" style={{"float": "left"}} checked={this.state.selectedPrivileges[index].scoped} 
                                                        onChange={(e) => {
                                                            this.checkBoxChange(this.state.selectedPrivileges[index].privilege_id,e)
                                                        }}
                                                        /></td>
                                                        <td>
                                                        <button
                                                        className="btn btn-danger"
                                                        onClick={(e) => {
                                                            e.preventDefault()
                                                            this.removePrivilege(this.state.selectedPrivileges[index].privilege_id)
                                                        }}>
                                                        X
                                                    </button></td>

                                                        </tr>

                                                        ))}
                                                        </tbody>

                                            </table>
                                            </div>
                                            </div>
                                            </div>
                                            </div>

                                            )
                                        }

                                         })()}


                                    </div>

                                    <div className="box-footer">
                                        <button
                                            className="btn btn-default"
                                            onClick={(e) => {
                                                e.preventDefault()
                                                this.onCancelClick()
                                            }}>
                                            Cancel
                                        </button>
                                        <button
                                            className="btn btn-info pull-right"
                                            onClick={(e) => {
                                                e.preventDefault()
                                                this.onSaveClick()
                                            }}>
                                            Save Changes
                                        </button>
                                    </div>
                                </div>
                    </div>
                </section>
            </div>
        )
    }

    keyedInputChange = (keyedName) => {
        console.log(keyedName)
        let keyedComponent =keyedName+"Component"
        let keyedErrorText =keyedName+"ErrorText"
        let keyedErrorData =keyedName+"ErrorData"
        let keyedSection =keyedName+"Section"
        let name=this[keyedComponent].value.trim()
        this.setState({[keyedName]:name})
        if(!name){
            this.setState({[keyedName] : null})
            return
        }
        this.setState({ [keyedErrorText]: false, [keyedErrorData]: '' })
        this[keyedSection].className = this[keyedSection].className.replace(" has-error", "")
    }

}
function mapStateToProps(state) {
    return {
        roles: state.roles,
        user: state.user,
    }
}

export default connect(mapStateToProps)(withRouter(AddEditRoles))


// WEBPACK FOOTER //
// ./src/modules/Roles/Components/AddEditRoles.js